module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "finalRiddle",
    staticClass: "c-final-riddle"
  }, [_c('div', {
    staticClass: "c-inari c-final-riddle__inari",
    class: {
      'c-inari--active': _vm.stage === 5
    }
  }, [_c('img', {
    attrs: {
      "src": (_vm.baseUrl + "img/inari.svg"),
      "alt": "INARI"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "c-final-riddle__lock"
  }, [_c('img', {
    attrs: {
      "src": (_vm.baseUrl + "img/lock.svg"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "c-final-riddle__wrap"
  }, [_c('div', {
    staticClass: "c-final-riddle__inner"
  }, [_c('h4', [_vm._v("Now for the final riddle!")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.questions[_vm.randomIndex].question))]), _vm._v(" "), _c('form', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.finalAnswer),
      expression: "finalAnswer"
    }],
    attrs: {
      "type": "number",
      "placeholder": "Your Answer",
      "min": "0"
    },
    domProps: {
      "value": (_vm.finalAnswer)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.finalAnswer = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "c-button c-button--primary c-button--thin",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.submitFinal($event)
      }
    }
  }, [(!_vm.checkingAnswer) ? _c('span', [_vm._v("Submit")]) : _vm._e(), (_vm.checkingAnswer) ? _c('img', {
    attrs: {
      "src": (_vm.baseUrl + "img/spinner.svg"),
      "alt": "Loading",
      "width": "30"
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.finalAnswerError),
      expression: "finalAnswerError"
    }],
    staticClass: "c-form__hint"
  }, [_vm._v("HINT: " + _vm._s(_vm.questions[_vm.randomIndex].hint))])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a8928452","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/FinalRiddle.vue
// module id = 68
// module chunks = 0